// This file is generated automatically by `scripts/build/fp.ts`. Please, don't change it.

import { isSameMonth as fn } from "../isSameMonth.js";
import { convertToFP } from "./_lib/convertToFP.js";

export const isSameMonth = convertToFP(fn, 2);

// Fallback for modularized imports:
export default isSameMonth;
